import { MAANDEN } from '../updates/formatUpdateDate'

/**
 * De periode van de facturatie: een kalendermaand. Standaard de vorige maand,
 * want die wordt aan het begin van de nieuwe maand gefactureerd.
 * AI-CONTEXT: See docs/features/facturatie-per-deelnemer.md
 */


/**
 * @typedef {object} MonthOption
 * @property {string} value - 'YYYY-MM'
 * @property {number} year
 * @property {number} month - 1-12
 * @property {string} label - bijv. 'september 2026'
 */

/** @param {number} n @returns {string} */
const pad = (n) => String(n).padStart(2, '0')

/**
 * @param {Date} now
 * @returns {{year: number, month: number}} De maand vóór `now` (1-12)
 */
const previousMonth = (now) => {
    const date = new Date(now.getFullYear(), now.getMonth() - 1, 1)
    return { year: date.getFullYear(), month: date.getMonth() + 1 }
}

/**
 * @param {number} year
 * @param {number} month - 1-12
 * @returns {string} Laatste dag van de maand als YYYY-MM-DD
 */
const periodEndKey = (year, month) => `${year}-${pad(month)}-${pad(new Date(year, month, 0).getDate())}`

/**
 * @param {Date} now
 * @param {number} count - Hoeveel maanden terug, de huidige meegerekend
 * @returns {Array<MonthOption>} Nieuwste eerst
 */
const monthOptions = (now, count) => Array.from({ length: count }, (_, i) => {
    const date = new Date(now.getFullYear(), now.getMonth() - i, 1)
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    return { value: `${year}-${pad(month)}`, year, month, label: `${MAANDEN[month - 1]} ${year}` }
})

export { previousMonth, periodEndKey, monthOptions }
